import { Card } from '@mantine/core';
import { GhostButton } from '@teamfabric/copilot-ui';
import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';

const StyledCardContent = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: row;
  .content__intro {
    height: 72px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .content__actions {
    height: 72px;
    min-width: 100px;
    width: 10vw;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    .btn__edit {
      cursor: pointer;
    }
  }
`;

const SchemaIntroList: FunctionComponent<{ schemas: any[] }> = ({ schemas }) => {
  const navigate = useNavigate();
  return (
    <>
      {schemas.map((schema, index) => (
        <Card key={`schema-${index}`} data-testid="schemaIntroList">
          <Card.Section>
            <StyledCardContent>
              <div data-testid="schema-content-intro" className="content__intro">
                <h2>{schema.name}</h2>
                <div>
                  <p>{schema.description || '--'}</p>
                </div>
              </div>
              <div className="content__actions">
                <GhostButton
                  className="btn__edit"
                  iconPosition="left"
                  iconSize={24}
                  icon="Edit"
                  onClickHandler={() => {
                    navigate('/schema/details');
                  }}
                  showIcon
                  text="Edit"
                  data-testid="schema-button-edit"
                />
              </div>
            </StyledCardContent>
          </Card.Section>
        </Card>
      ))}
    </>
  );
};

export default SchemaIntroList;
